<template>
  <td class="text-xs-right">
    <payment-brand :brand="brand" :size="32" />
  </td>
</template>

<script>
export default {
  props: ["brand"],
  components: {
    PaymentBrand: () => import("@/components/desktop/brand/PaymentBrand.vue"),
  },
};
</script>

